<template>
  <div>
    <div class="d-flex justify-content-end">
      <button class="btn btn-warning mb-1" @click="showAddCompanyModal">
        Add Company
      </button>
    </div>
    <div class="modal fade" id="AddCompany" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content custom-modal">
          <div class="modal-header">
            <h5 class="modal-title">Add Company</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          
          <!-- Loader should only show when actively loading -->
          <div v-if="loader" class="loader-overlay">
            <div class="fancy-loader"></div>
          </div>

          <!-- Success Message -->
          <div v-if="successmsg" class="alert alert-success alert-dismissible fade show m-3" role="alert">
            <i class="fas fa-check-circle me-2"></i>
            {{ successmsg }}
            <button type="button" class="btn-close" @click="successmsg = ''"></button>
          </div>

          <!-- Error Message -->
          <div v-if="duplicate_error" class="alert alert-danger alert-dismissible fade show m-3" role="alert">
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ duplicate_error }}
            <button type="button" class="btn-close" @click="duplicate_error = ''"></button>
          </div>

          <div class="modal-body" :class="{ 'blur-content': loader }">
            <form @submit.prevent="submitCompany" ref="companyForm">
              <div class="row g-3">
                <!-- Required Fields -->
                <div class="col-md-4">
                  <label class="form-label">Company Name *</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="name"
                    placeholder="Company Name"
                    :class="{ 'is-invalid': errors.name }"
                  />
                  <div v-if="errors.name" class="invalid-feedback d-block">
                    {{ errors.name }}
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">SOR Company ID *</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="sor_company_id"
                    placeholder="SOR Company ID"
                    :class="{ 'is-invalid': errors.sor_company_id }"
                  />
                  <div v-if="errors.sor_company_id" class="invalid-feedback d-block">
                    {{ errors.sor_company_id }}
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Primary ID *</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="primary_id"
                    placeholder="Primary ID"
                    :class="{ 'is-invalid': errors.primary_id }"
                  />
                  <div v-if="errors.primary_id" class="invalid-feedback d-block">
                    {{ errors.primary_id }}
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Start Date *</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="start_date"
                    :class="{ 'is-invalid': errors.start_date }"
                  />
                  <div v-if="errors.start_date" class="invalid-feedback d-block">
                    {{ errors.start_date }}
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">End Date *</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="end_date"
                    :class="{ 'is-invalid': errors.end_date }"
                  />
                  <div v-if="errors.end_date" class="invalid-feedback d-block">
                    {{ errors.end_date }}
                  </div>
                </div>

                <!-- Optional Fields -->
                <div class="col-md-4">
                  <label class="form-label">Legal Name</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="legal_name"
                    placeholder="Legal Name"
                    :class="{ 'is-invalid': errors.legal_name }"
                  />
                  <div v-if="errors.legal_name" class="invalid-feedback d-block">
                    {{ errors.legal_name }}
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Government ID</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="gov_id"
                    placeholder="Government ID"
                    :class="{ 'is-invalid': errors.gov_id }"
                  />
                  <div v-if="errors.gov_id" class="invalid-feedback d-block">
                    {{ errors.gov_id }}
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Government ID Type</label>
                  <select v-model="gov_id_type" class="form-control">
                    <option value="">-- Select / Clear Option --</option>
                    <option value="TIN">TIN</option>
                    <option value="EIN">EIN</option>
                    <option value="SSN">SSN</option>
                    <option value="VAT">VAT</option>
                    <option value="OTHER">Other</option>
                  </select>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Name Control</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="name_control"
                    placeholder="Name Control"
                    :class="{ 'is-invalid': errors.name_control }"
                  />
                  <div v-if="errors.name_control" class="invalid-feedback d-block">
                    {{ errors.name_control }}
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">SOR</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="sor"
                    placeholder="SOR"
                    :class="{ 'is-invalid': errors.sor }"
                  />
                  <div v-if="errors.sor" class="invalid-feedback d-block">
                    {{ errors.sor }}
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Likely Primary ID</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="likely_primary_id"
                    placeholder="Likely Primary ID"
                    :class="{ 'is-invalid': errors.likely_primary_id }"
                  />
                  <div v-if="errors.likely_primary_id" class="invalid-feedback d-block">
                    {{ errors.likely_primary_id }}
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Duplicate ID</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="dup_id"
                    placeholder="Duplicate ID"
                    :class="{ 'is-invalid': errors.dup_id }"
                  />
                  <div v-if="errors.dup_id" class="invalid-feedback d-block">
                    {{ errors.dup_id }}
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Data Manager Name</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="dm_name"
                    placeholder="Data Manager Name"
                    :class="{ 'is-invalid': errors.dm_name }"
                  />
                  <div v-if="errors.dm_name" class="invalid-feedback d-block">
                    {{ errors.dm_name }}
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Status</label>
                  <select v-model="status" class="form-control">
                    <option value="">-- Select / Clear Option --</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Pending">Pending</option>
                    <option value="Suspended">Suspended</option>
                  </select>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Entity ID</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="entity_id"
                    placeholder="Entity ID"
                    :class="{ 'is-invalid': errors.entity_id }"
                  />
                  <div v-if="errors.entity_id" class="invalid-feedback d-block">
                    {{ errors.entity_id }}
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Corporate Phone</label>
                  <input
                    type="tel"
                    class="form-control"
                    v-model="corporate_phone"
                    placeholder="Corporate Phone"
                    :class="{ 'is-invalid': errors.corporate_phone }"
                  />
                  <div v-if="errors.corporate_phone" class="invalid-feedback d-block">
                    {{ errors.corporate_phone }}
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Corporate Email</label>
                  <input
                    type="email"
                    class="form-control"
                    v-model="corporate_email"
                    placeholder="Corporate Email"
                    :class="{ 'is-invalid': errors.corporate_email }"
                  />
                  <div v-if="errors.corporate_email" class="invalid-feedback d-block">
                    {{ errors.corporate_email }}
                  </div>
                </div>

                <div class="col-12">
                  <label class="form-label">Comments</label>
                  <textarea
                    class="form-control"
                    v-model="comments"
                    placeholder="Comments"
                    rows="3"
                    :class="{ 'is-invalid': errors.comments }"
                  ></textarea>
                  <div v-if="errors.comments" class="invalid-feedback d-block">
                    {{ errors.comments }}
                  </div>
                </div>
              </div>
              <div class="text-end mt-3">
                <button type="submit" class="btn btn-success" :disabled="loader">
                  <span v-if="loader" class="spinner-border spinner-border-sm me-2"></span>
                  {{ loader ? 'Adding...' : 'Submit' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as bootstrap from "bootstrap";
import { AddCompany } from "../End Points/api";

export default {
  name: "AddCompanyForm",
  data() {
    return {
      // Required fields
      name: "",
      sor_company_id: "",
      primary_id: "",
      start_date: "",
      end_date: "",
      
      // Optional fields
      legal_name: "",
      gov_id: "",
      gov_id_type: "",
      name_control: "",
      sor: "",
      likely_primary_id: "",
      dup_id: "",
      dm_name: "",
      status: "",
      comments: "",
      entity_id: "",
      corporate_phone: "",
      corporate_email: "",
      
      modalInstance: null,
      errors: {},
      loader: false,
      successmsg: "",
      duplicate_error: ""
    };
  },

  methods: {
    successToast(msg) {
      if (this.$toast) {
        this.$toast.success(msg, { timeout: 4000 });
      } else {
        console.log("Success:", msg);
      }
    },
    errorToast(msg) {
      if (this.$toast) {
        this.$toast.error(msg, { timeout: 5000 });
      } else {
        console.error("Error:", msg);
      }
    },

    validateForm() {
      this.errors = {};
      this.successmsg = "";
      this.duplicate_error = "";

      // Required field validation
      if (!this.name) {
        this.errors.name = "Company Name is required.";
      } else if (this.name.length > 255) {
        this.errors.name = "Company Name must not exceed 255 characters.";
      }

      if (!this.sor_company_id) {
        this.errors.sor_company_id = "SOR Company ID is required.";
      } else if (this.sor_company_id.length > 255) {
        this.errors.sor_company_id = "SOR Company ID must not exceed 255 characters.";
      }

      if (!this.primary_id) {
        this.errors.primary_id = "Primary ID is required.";
      } else if (this.primary_id.length > 255) {
        this.errors.primary_id = "Primary ID must not exceed 255 characters.";
      }

      if (!this.start_date) {
        this.errors.start_date = "Start Date is required.";
      }

      if (!this.end_date) {
        this.errors.end_date = "End Date is required.";
      }

      // Date validation
      if (this.start_date && this.end_date) {
        const startDate = new Date(this.start_date);
        const endDate = new Date(this.end_date);
        
        if (endDate <= startDate) {
          this.errors.end_date = "End date must be after start date.";
        }
      }

      // Optional field length validation
      const optionalFields = [
        'legal_name', 'gov_id', 'name_control', 'sor', 'likely_primary_id',
        'dup_id', 'dm_name', 'entity_id', 'corporate_phone', 'corporate_email', 'comments'
      ];

      optionalFields.forEach(field => {
        if (this[field] && this[field].length > 255) {
          this.errors[field] = "Must not exceed 255 characters.";
        }
      });

      // Email validation
      if (this.corporate_email && !this.isValidEmail(this.corporate_email)) {
        this.errors.corporate_email = "Please enter a valid email address.";
      }

      const hasErrors = Object.keys(this.errors).length > 0;
      
      // Scroll to first error if there are errors
      if (hasErrors) {
        this.$nextTick(() => {
          this.scrollToFirstError();
        });
      }

      return !hasErrors;
    },

    scrollToFirstError() {
      const firstErrorElement = this.$el.querySelector('.is-invalid');
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        });
        firstErrorElement.focus();
      }
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    showAddCompanyModal() {
      this.modalInstance = new bootstrap.Modal(document.getElementById("AddCompany"));
      this.modalInstance.show();
      this.resetForm();
    },

    async submitCompany() {
      if (!this.validateForm()) {
        return;
      }
      
      this.duplicate_error = "";
      this.successmsg = "";
      this.loader = true;
      
      try {
        const companyData = {
          name: this.name,
          sor_company_id: this.sor_company_id,
          primary_id: this.primary_id,
          start_date: this.start_date,
          end_date: this.end_date,
          legal_name: this.legal_name || "",
          gov_id: this.gov_id || "",
          gov_id_type: this.gov_id_type || "",
          name_control: this.name_control || "",
          sor: this.sor || "",
          likely_primary_id: this.likely_primary_id || "",
          dup_id: this.dup_id || "",
          dm_name: this.dm_name || "",
          status: this.status || "",
          comments: this.comments || "",
          entity_id: this.entity_id || "",
          corporate_phone: this.corporate_phone || "",
          corporate_email: this.corporate_email || ""
        };

        console.log("Submitting company data:", companyData);

        const response = await AddCompany(companyData);
        console.log("API Response:", response);

        // Check if response exists and handle different success scenarios
        if (response && (response.status === 201 || response.status === 200 || response.status === 204)) {
          this.successmsg = response.data?.message || "Company added successfully!";
       /*    this.successToast(this.successmsg); */
          this.$emit("company-added");

          // Auto close modal after success
          setTimeout(() => {
            const modalEl = document.getElementById("AddCompany");
            const modalInstance = bootstrap.Modal.getInstance(modalEl);
            if (modalInstance) {
              modalInstance.hide();
            }
            this.resetForm();
          }, 1500);

        } else if (response) {
          // Handle other success cases where response exists but status is different
          console.log("Company added with response:", response);
          this.successmsg = "Company added successfully!";
          this.successToast(this.successmsg);
          this.$emit("company-added");

          setTimeout(() => {
            const modalEl = document.getElementById("AddCompany");
            const modalInstance = bootstrap.Modal.getInstance(modalEl);
            if (modalInstance) {
              modalInstance.hide();
            }
            this.resetForm();
          }, 1500);
        } else {
          // Handle case where response is undefined but API call succeeded
          console.log("Company added (no response object)");
          this.successmsg = "Company added successfully!";
          this.successToast(this.successmsg);
          this.$emit("company-added");

          setTimeout(() => {
            const modalEl = document.getElementById("AddCompany");
            const modalInstance = bootstrap.Modal.getInstance(modalEl);
            if (modalInstance) {
              modalInstance.hide();
            }
            this.resetForm();
          }, );
        }

      } catch (error) {
        console.error("Add company error:", error);
        console.error("Error details:", {
          message: error.message,
          response: error.response,
          stack: error.stack
        });

        // Handle different error scenarios
        if (error.response) {
          // Server responded with error status
          const serverErrors = error.response.data?.errors || error.response.data;
          
          if (serverErrors) {
            this.errors = { ...this.errors, ...serverErrors };

            if (serverErrors.name) {
              this.errors.name = Array.isArray(serverErrors.name) ? serverErrors.name[0] : serverErrors.name;
              this.duplicate_error = "Company with this name already exists.";
            }

            if (serverErrors.sor_company_id) {
              this.errors.sor_company_id = Array.isArray(serverErrors.sor_company_id) ? serverErrors.sor_company_id[0] : serverErrors.sor_company_id;
              this.duplicate_error = "SOR Company ID already exists.";
            }

            if (serverErrors.primary_id) {
              this.errors.primary_id = Array.isArray(serverErrors.primary_id) ? serverErrors.primary_id[0] : serverErrors.primary_id;
              this.duplicate_error = "Primary ID already exists.";
            }

            // Scroll to first error after setting errors
            this.$nextTick(() => {
              this.scrollToFirstError();
            });

          } else {
            this.errorToast(error.response.data?.message || "Server error occurred.");
          }
        } else if (error.request) {
          // Request was made but no response received
          console.error("No response received:", error.request);
          this.errorToast("Network error. Please check your connection.");
        } else {
          // Something else happened
          console.error("Error:", error.message);
          this.errorToast("Something went wrong. Please try again.");
        }
      } finally {
        this.loader = false;
      }
    },

    resetForm() {
      Object.assign(this.$data, this.$options.data());
    }
  }
};
</script>

<style scoped>
.custom-modal {
  height: auto;
  max-height: 80vh;
  overflow-y: auto;
  padding: 1rem;
  border-radius: 1rem;
  margin: auto;
}

.modal-content {
  width: 80%;
  max-width: 80%;
}

/* Fixed Loader Styles */
.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-radius: 1rem;
}

/* Blur effect only when loading */
.blur-content {
  filter: blur(2px);
  pointer-events: none;
}

.fancy-loader {
  width: 60px;
  height: 60px;
  border: 6px solid #e0e0e0;
  border-top: 6px solid #007bff;
  border-radius: 50%;
  animation: slow-spin 1.8s ease-in-out infinite;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.3);
}

@keyframes slow-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Remove backdrop-filter from modal itself */
.modal {
  z-index: 1060 !important;
}

.modal-backdrop {
  z-index: 1050 !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    max-width: 95%;
  }
  
  .custom-modal {
    padding: 0.5rem;
  }
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.form-control {
  border: 1px solid #ddd;
  border-radius: 0.375rem;
  padding: 0.5rem 0.75rem;
}

.form-control:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-control.is-invalid {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: #dc3545;
}

.btn-success {
  background-color: #198754;
  border-color: #198754;
  padding: 0.5rem 1.5rem;
}

.btn-success:hover:not(:disabled) {
  background-color: #157347;
  border-color: #146c43;
}

.btn-success:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-warning {
  background-color: #ffc107;
  border-color: #ffc107;
  color: #000;
}

.btn-warning:hover {
  background-color: #ffca2c;
  border-color: #ffc720;
  color: #000;
}

.alert {
  margin: 1rem;
}

.alert-success {
  background-color: #d1e7dd;
  border-color: #badbcc;
  color: #0f5132;
}

.alert-danger {
  background-color: #f8d7da;
  border-color: #f5c2c7;
  color: #842029;
}
</style>